import { render } from "./OrderMulti.vue?vue&type=template&id=d5d8a6be"
import script from "./OrderMulti.vue?vue&type=script&lang=js"
export * from "./OrderMulti.vue?vue&type=script&lang=js"

import "./OrderMulti.vue?vue&type=style&index=0&id=d5d8a6be&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__